import { render, staticRenderFns } from "./AccountNameEditForm.vue?vue&type=template&id=81c1e6a6&"
import script from "./AccountNameEditForm.vue?vue&type=script&lang=js&"
export * from "./AccountNameEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports